export const box = () => (
  <path
    d="M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12m9 4V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
